import { render, staticRenderFns } from "./Box.svg.vue?vue&type=template&id=d2d9cab2"
import script from "./Box.svg.vue?vue&type=script&lang=ts"
export * from "./Box.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2d9cab2')) {
      api.createRecord('d2d9cab2', component.options)
    } else {
      api.reload('d2d9cab2', component.options)
    }
    module.hot.accept("./Box.svg.vue?vue&type=template&id=d2d9cab2", function () {
      api.rerender('d2d9cab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/viewer/Box.svg.vue"
export default component.exports